export default __webpack_public_path__ + "fonts/gotham_ssm_book.eot";